import {
  CompaniesInfiniteSelectField,
  FloatingFormItem,
} from '@/components/_common';
import { useWorkorderImportAudatexweb } from '@/core/domain/workorder/WorkOrdersImports/WorkOrderImports.hooks';
import { WorkOrderImportAudatexwebForm } from '@/core/domain/workorder/WorkOrdersImports/WorkOrderImports.types';
import { useDefaultEmptyFieldError } from '@/hooks';
import { Button, Checkbox, Col, Divider, Form, Input, Row } from 'antd';
import { ImportModalFormProps } from '..';
import { ImportComplementOrigin } from '@/core/domain/workorder/WorkOrdersImports/WorkOrderImports.enum';
import HelpIcon from '@/components/_common/HelpIcon/idex';

type Props = ImportModalFormProps;

const ImportAudatexwebForm: React.FC<Props> = ({ onClose, onImported }) => {
  const [form] = Form.useForm<WorkOrderImportAudatexwebForm>();
  const requiredRule = useDefaultEmptyFieldError();
  const importAudatexweb = useWorkorderImportAudatexweb();

  function handleClose() {
    form.resetFields();
    onClose();
  }

  async function handleSubmit(values: WorkOrderImportAudatexwebForm) {
    const result = await importAudatexweb.mutateAsync(values);
    onImported({ data: result, origin: ImportComplementOrigin.AudatexWeb });
  }

  return (
    <Form name="import-audatexweb" form={form} onFinish={handleSubmit}>
      <Row gutter={[16, 16]}>
        <Col span={24} md={12}>
          <FloatingFormItem
            name="companyId"
            label="Empresa"
            rules={[requiredRule]}
          >
            <CompaniesInfiniteSelectField />
          </FloatingFormItem>
        </Col>

        <Col span={24} md={12}>
          <FloatingFormItem
            name="BudgetNumber"
            label="Número do orçamento Audatexweb"
            rules={[requiredRule]}
          >
            <Input />
          </FloatingFormItem>
        </Col>

        <Col span={24}>
          <HelpIcon title="Ao ativar esta opção, todas as peças não fornecidas serão tratadas como peças digitadas.">
            <Form.Item
              noStyle
              name="onlyTypedParts"
              initialValue={false}
              valuePropName="checked"
            >
              <Checkbox>Somente peças digitadas</Checkbox>
            </Form.Item>
          </HelpIcon>
        </Col>
      </Row>

      <Divider />

      <Row justify="end" gutter={[16, 16]}>
        <Col>
          <Button onClick={handleClose}>Cancelar</Button>
        </Col>
        <Col>
          <Button
            type="primary"
            htmlType="submit"
            loading={importAudatexweb.isLoading}
          >
            Importar orçamento
          </Button>
        </Col>
      </Row>
    </Form>
  );
};

export default ImportAudatexwebForm;
